import PropTypes from 'prop-types'
import { callApi } from './callApi'

export function GetEmailPreferences (email) {
    return callApi({ url: `EmailPreference/GetCustomerID?emailAddress=${email}` })
}

GetEmailPreferences.propTypes = {
    email: PropTypes.string.isRequired
}